import { DefaultTransformRegistry } from './DefaultTransformRegistry';
import { rowShiftTransformCreator, RowShiftType } from './calculations/RowShiftCalculation';
import { timeShiftTransformCreator, TimeShiftType } from './calculations/TimeShiftCalculation';
import { TransformRegistry } from './transform';

/**
 * The Query to pass in to the getMetricDataPointsByIds vizportal endpoint.
 *
 * Clients should use the associated `build` function to generate the correct
 * query for the engine version they are using, and avoid contructing this
 * object by hand.
 */
export interface DataPointsQuery {
  v1: { calculations: Calculations };
}

type Calculations = {
  [key: string]: number | undefined;
};

export namespace DataPointsQuery {
  export const build = (registry: TransformRegistry = DefaultTransformRegistry): DataPointsQuery => {
    const calcNames = Object.keys(registry);
    const defaults: Record<string, number> = {};
    if (registry[TimeShiftType] === timeShiftTransformCreator) {
      defaults[TimeShiftType] = 2;
    }
    if (registry[RowShiftType] === rowShiftTransformCreator) {
      defaults[RowShiftType] = 2;
    }
    const calculations = {
      ...calcNames.reduce((calcs, calcName) => {
        calcs[calcName] = 1;
        return calcs;
      }, {} as Calculations),
      ...defaults,
    };
    return {
      v1: {
        calculations,
      },
    };
  };
}
